import {useEffect, useRef, useState} from "react";

const ConfigurationControlMobile = ({ rightMenuToggle, menuDisplayToggle, setRightMenuToggle, scenarioType, handleClickScenario, projectionType, handleClickProjection, mouseMode, handleClickMouseMode, isolineValue, isoLineChecked,
                                        handleChangeIsoLine, isoLineLabelChecked, handleChangeIsoLineSlide, overlayType }) => {
    const [classNameToggle, setClassNameToggle] = useState(false);
    const [styleToggle, setStyleToggle] = useState(false);
    const classNameTimerId = useRef(null);
    const styleTimerId = useRef(null);

    useEffect(() => {
        //해당 사이드 이펙트는 설정창이 아래에서 올라올때 애니메이션 효과를 주기 위해서 만들어졌다.
        //설정창은 vrt02클래스에 on이 추가되고 style에 display가 block가 됫을때 보인다.
        //이 두가지가 동시에 업데이트 되어 렌더링될 경우 애니메이션 효과가 나타나지 않는다.
        //열릴때는 style이 먼저 적용된 후에 클래스가 적용되어야하고
        //닫힐때는 클래스가 먼저 적용된 후에 style이 적용되어야 한다.
        //이러한 시간차를 구현하기 위해 timeout을 이용하여 클래스이름과 스타일을 따로 렌더링 되게 하였다.
        if (rightMenuToggle === 'configuration') {//설정창 켜질때
            setStyleToggle(true);
            classNameTimerId.current = setTimeout(() => setClassNameToggle(true), 0);
        } else { //설정창 꺼질때
            setClassNameToggle(false);
            styleTimerId.current = setTimeout(() => setStyleToggle(false), 300);
        }

        return () => {
            clearTimeout(classNameTimerId.current);
            clearTimeout(styleTimerId.current);
        }
    }, [rightMenuToggle])

    return <div className={classNameToggle ? 'vrt02 on':'vrt02'} style={menuDisplayToggle === true && styleToggle ? {display: 'block'} : {display: 'none'}}>
        <div className="vrt_close01" onTouchStart={() => setRightMenuToggle('none')}>
            <a href="javascript:;" className="btn_vrt_close01" ><span className="blind">닫기</span></a>
        </div>
        <div className="vrt02_in">
            <div className="vrt02_con">
                <div className="dv1">
                    <div className="vrt_tit01">
                        <h2>출처</h2>
                    </div>
                    <div className="vrt_sel01 grd2 mt13">
                        <ul className="cl">
                            <li><a href="javascript:;" className={scenarioType === "ssp585" ? "on" : "off"} title="CMIP6/SSP585" onClick={handleClickScenario("ssp585")}>CMIP 6/SSP585</a></li>
                            <li><a href="javascript:;" className={scenarioType === "ssp126" ? "on" : "off"} title="CMIP6/SSP126" onClick={handleClickScenario("ssp126")}>CMIP 8/SSP126</a></li>
                        </ul>
                    </div>
                </div>
                <div className="dv1 mt48">
                    <div className="vrt_tit01">
                        <h2>지도</h2>
                    </div>
                    <div className="vrt_sel02 mt13">
                        <ul className="cl">
                            <li><a href="javascript:;" className={projectionType === "atlantis" ? "on" : "off"} title="Atlantis" onClick={handleClickProjection("atlantis")}>A</a></li>
                            <li><a href="javascript:;" className={projectionType === "azimuthal_equidistant" ? "on" : "off"} title="Azimuthal Equidistant" onClick={handleClickProjection("azimuthal_equidistant")}>AE</a></li>
                            <li><a href="javascript:;" className={projectionType === "conic_equidistant" ? "on" : "off"} title="Conic Equidistant" onClick={handleClickProjection("conic_equidistant")}>CE</a></li>
                            <li><a href="javascript:;" className={projectionType === "equirectangular" ? "on" : "off"} title="Equirectangular" onClick={handleClickProjection("equirectangular")}>E</a></li>
                            <li><a href="javascript:;" className={projectionType === "orthographic" ? "on" : "off"} title="Orthographic" onClick={handleClickProjection("orthographic")}>O</a></li>
                            <li><a href="javascript:;" className={projectionType === "waterman" ? "on" : "off"} title="Waterman Butterfly" onClick={handleClickProjection("waterman")}>WB</a></li>
                            <li><a href="javascript:;" className={projectionType === "stereographic" ? "on" : "off"} title="Stereographic" onClick={handleClickProjection("stereographic")}>S</a></li>
                            <li><a href="javascript:;" className={projectionType === "winkel3" ? "on" : "off"} title="Winkel Tripel" onClick={handleClickProjection("winkel3")}>W3</a></li>
                        </ul>
                    </div>
                </div>
                <div className="dv1 mt48">
                    <div className="vrt_tit01">
                        <h2>설정1</h2>
                    </div>
                    <div className="vrt_sel01 grd3 mt16">
                        <ul className="cl">
                            <li><a href="javascript:;" className={mouseMode === "basic" ? "on" : "off"} title="basic" onClick={handleClickMouseMode("basic")}>기본</a></li>
                            <li><a href="javascript:;" className={mouseMode === "areaMean" ? "on" : "off"} title="areaMean" onClick={handleClickMouseMode("areaMean")}>영역평균</a></li>
                            {(overlayType === 'wind' || overlayType === 'temp') ? <li><a href="javascript:;" className={mouseMode === "crossSection" ? "on" : "off"} title="crossSection" onClick={handleClickMouseMode("crossSection")}>연직단면</a></li> : null}
                        </ul>
                    </div>
                </div>
                <div className="dv1 mt48">
                    <div className="vrt_tit01">
                        <h2>설정2</h2>
                    </div>
                    <div className="vrt_sel03 cl mt16">
                        <div className="w1">
                            <label htmlFor="rd01">등치선({Number(isolineValue*0.1).toFixed(1)})</label>
                            <span className="chk_onoff01">
                            <input type="checkbox" checked={isoLineChecked === true ? "checked" :  ""} id="rd01" onChange={handleChangeIsoLine("isoLineChecked")}/>
                            <span></span>
                        </span>
                        </div>
                        <div className="w1">
                            <label htmlFor="rd02">레이블</label>
                            <span className="chk_onoff01">
                            <input type="checkbox" checked={isoLineLabelChecked === true ? "checked" :  ""} id="rd02" onChange={handleChangeIsoLine("isoLineLabelChecked")}/>
                            <span></span>
                        </span>
                        </div>
                    </div>
                    <div className="slider2_wrap">
                        <div id="slider2" className="slider">
                            <output className="slider-output" style={{left:isolineValue + '%'}}>{Number(isolineValue*0.1).toFixed(1)}</output>
                            <div className="slider-track">
                                <div className="slider-thumb" style={{left:isolineValue + '%'}}></div>
                                <div className="slider-level" style={{width:isolineValue + '%'}}></div>
                            </div>
                            <input className="slider-input" type="range" value={isolineValue} step={1} min={0} max={100} onChange={handleChangeIsoLineSlide}/>
                        </div>
                    </div>
                    {/*<div className="st_btm_btn mt36">*/}
                    {/*    <ul>*/}
                    {/*        <li><a href="#" className="btn01">취소</a></li>*/}
                    {/*        <li><a href="#" className="btn02">확인</a></li>*/}
                    {/*    </ul>*/}

                    {/*</div>*/}
                </div>
            </div>
        </div>
    </div>
}

export default ConfigurationControlMobile;